import AppLogoSvg from '../assets/images/tadreamk_logo.svg';

export const APP_CONFIG = {
  LOGO_URL: AppLogoSvg,

  COMPANY_NAME: 'TadReamk',
  PRODUCT_NAME: 'TadReamk Surveillance',

  API_BASE_URL:
    process.env.REACT_APP_API_URL,

  API_PATENTINFO_URL:
    process.env.REACT_APP_API_PATENTINFO_URL,

  MAIN_WEBSITE_API_URL:
    process.env.REACT_APP_MAIN_WEBSITE_API_URL,

  MAIN_WEBSITE_ORIGIN:
    process.env.REACT_APP_MAIN_WEBSITE_ORIGIN,

  SOCIAL_LINKS: {
    LINKEDIN: 'https://www.linkedin.com/company/tadreamk/',
    GITHUB: 'https://github.com/tadreamk/tadreamk-python'
  }
};
